import { render } from "./insure-daily-ax.vue?vue&type=template&id=7db8e44e&scoped=true&ts=true"
import script from "./insure-daily-ax.vue?vue&type=script&lang=ts"
export * from "./insure-daily-ax.vue?vue&type=script&lang=ts"

import "./insure-daily-ax.vue?vue&type=style&index=0&id=7db8e44e&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db8e44e"]])

export default __exports__